import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { ReactComponent as CheckIcon } from "resources/images/check.svg"
import HTTPClient from "services/HTTPClient";
import Spinner from "./Spinner";
import { Collapse } from "antd";

const useMutateArticle = (id) => {
  return useMutation(async (is_approved: boolean) => {
    const url = `/brains/doc/${id}`
    let response = await HTTPClient.get().patchDataForJSONResult(url, {
      is_approved
    })
    return response
  },)
}

const useMutateVocab = (id) => {
  return useMutation(async (is_approved: boolean) => {
    const url = `/brains/vocab/${id}`
    let response = await HTTPClient.get().patchDataForJSONResult(url, {
      is_approved
    })
    return response
  },)
}

export default function Article({ article }) {
  const [isApproved, setIsApproved] = useState(article.is_approved)
  const { isLoading: isUpdating, mutateAsync } = useMutateArticle(article.id)

  const toggleApproval = async (e) => {
    console.log("Approve article")
    let newStatus = !isApproved
    await mutateAsync(newStatus)
    setIsApproved(newStatus)
    e.stopPropagation()
    e.preventDefault()
  }

  return (<div key={article.id} className='box my-2'>
    <div className="between mb-3">
      <h2 className="is-size-5">
        <strong>
          Article #{article.id} - {article.reference_id}
        </strong>
      </h2>
      <div>
        {
          isUpdating
            ? <span className='tag blink'>
              <Spinner className="mr-2" /> Updating...
            </span>
            : !isApproved
              ? <span className='tag c-pointer' onClick={toggleApproval}>Approve</span>
              : <span className='tag is-success c-pointer' onClick={toggleApproval}>
                <CheckIcon className="mr-2" />
                Approved
              </span>
        }
      </div>
    </div>
    <Collapse
      items={[{
        key: '1', label: <div className="between">
          {article.title}


        </div>, children: <p>{article.body}</p>
      }]}
    />
    <div className="mt-3" />
    {(article.vocabs || []).map(vocab => {
      return <Vocab vocab={vocab} />
    })}
  </div>);
}

function Vocab({ vocab }) {
  const [isApproved, setIsApproved] = useState(vocab.is_approved)
  const { isLoading: isUpdating, mutateAsync } = useMutateVocab(vocab.id)

  const toggleApproval = async () => {
    console.log("Approve vocab")
    let newStatus = !isApproved
    await mutateAsync(newStatus)
    setIsApproved(newStatus)
  }

  return <div onClick={toggleApproval} key={vocab.id} className={`tag d-block mb-2 c-pointer ${isUpdating ? "blink" : ""} ${isApproved ? "is-success" : ""}`}>
    <div className="between h-100">
      <span>
        {vocab.word} - {vocab.definition}
      </span>
      {
        isUpdating && <Spinner className="d-inline-block mr-1" />
      }
    </div>
  </div>
}
